export const getComparison = `query CalculationInput($comparisonId: UUID!) {
  calculationInput(comparisonId: $comparisonId) {
    masterAgreementPackages {
      effectiveDate
      paymentTermInMonths
      objectBuildings {
        addresses {
          postalCode
          houseNumber
          houseLetter
        }
        constructionYear
        constructionOfRoof
        constructionOfFloors
        constructionOfWalls
        homeType
        propertyUseType
        rebuildCost
        solarPanels
        burglaryPreventionMeasuresPresent
        houseSurfaceAreaSquareMeters
        volumeInCubicMeters
        numberRooms
        propertyOfInsured
        recentBathroomKitchenLivingRoom
        wozAppraisalValue
        consideredMonumentByOwner
      }
      coverageBuildings {
        coverageCode
        deductibleAmount
        insuredFamilyComposition
      }
      coverageHomes {
        coverageCode
        deductibleAmount
        insuredFamilyComposition
        sumInsured
        insuredAmountTenantInterest
        insuredAmountMusicalInstruments
        insuredAmountCollections
        insuredAmountComputerEquipment
        insuredAmountValuablesOutdoors
        insuredAmountJewelry
        insuredAmountOther
        customProperties {
          insuredAmountAudioVideo
          insuredAmountAntiques
          insuredAmountArt
        }
      }
      coverageLiabilities {
        deductibleAmount
        insuredFamilyComposition
        sumInsured
      }
      objectGlasses {
        translucentMaterialType
      }
      partyPolicyHolders {
        birthDate
      }
      underwritingValuePreventionMeters {
        dateBirthMainBreadwinner
        monthlyNetIncomeMainBreadwinner
      }
    }
  }
}
`;
